// extracted by mini-css-extract-plugin
module.exports = {"page-grid":"Home_page-grid__EHc_h","cta":"Home_cta__Thpaw","sub-title":"Home_sub-title__w2Dsv","section":"Home_section__tQ64R"};